<template>
  <div class="bg-white rounded box-shadow p-1">
    <b-modal id="land-buy-modal" size="lg" title="Land Buy Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_type_id">Type of Remaining Land <span class="c-required">*</span></label>
            <select v-model="land_buy.land_type_id" v-validate="'required'" id="land_type_id" name="land_type_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Land Type</option>
              <option v-for="(land_type, index) in land_types" v-bind:value="land_type.id" :key="index">{{ land_type.id }} : {{ land_type.land_type_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select valid land type</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_mouza">Mouza <span class="c-required">*</span></label>
            <input type="text" v-model="land_buy.land_mouza"  v-validate="'required'" id="land_mouza" name="land_mouza" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Mouza is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_union">Union <span class="c-required">*</span></label>
            <input type="text" v-model="land_buy.land_union"  v-validate="'required'"  id="land_union" name="land_union" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Union is required</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_upazila">Upazila <span class="c-required">*</span></label>
            <input type="text" v-model="land_buy.land_upazila"  v-validate="'required'" id="land_upazila" name="land_upazila" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Upazila is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_district">District <span class="c-required">*</span></label>
            <input type="text" v-model="land_buy.land_district"  v-validate="'required'"  id="land_district" name="land_district" class="form-control form-control-sm"/>
            <div class="invalid-feedback">District is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_division">Division <span class="c-required">*</span></label>
            <input type="text" v-model="land_buy.land_division"  v-validate="'required'"  id="land_division" name="land_division" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Division is required</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_location">Addition Land Location <span class="c-required">*</span></label>
            <input type="text" v-model="land_buy.land_location"  v-validate="'required'"  id="land_location" name="land_location" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Addition land location is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="plot">Plot <span class="c-required">*</span></label>
            <input type="number" v-model="land_buy.plot" v-validate="'required|numeric'" id="plot" name="plot" class="form-control form-control-sm" />
            <div class="invalid-feedback">Please enter plot number also in number format</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_amount">Land Amount <span class="c-required">*</span></label>
            <input type="number" v-model="land_buy.land_amount" v-validate="'required|numeric'" id="land_amount" name="land_amount" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Please enter land amount also in number format</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="document_no">Document No. <span class="c-required">*</span></label>
            <input type="number" v-model="land_buy.document_no"  v-validate="'required'"  id="document_no" name="document_no" class="form-control form-control-sm" />
            <div class="invalid-feedback">Please enter value in number format</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="date">Date <span class="c-required">*</span></label>
            <datepicker v-model="land_buy.date" v-validate="'required'"  id="date" name="date" :format="customDate" placeholder="Date"></datepicker>
            <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;" v-if="errors.has('date')">Date is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="stamp_fee">Stamp Fee <span class="c-required">*</span></label>
            <input type="number" v-model="land_buy.stamp_fee"  v-validate="'required|numeric'"  id="stamp_fee" name="stamp_fee" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Please enter stamp fee also in number format</div>
          </div>

        </div>
        <div class="form-row mt-2">
<!--          <div class="col-md-6 col-sm-6 col-lg-4">-->
<!--            <label for="is_inc_pay">Is Inc Pay?</label>-->
<!--            <select v-model="land_buy.is_inc_pay" id="is_inc_pay" name="is_inc_pay" class="form-control form-control-sm">-->
<!--              <option selected value="0">No</option>-->
<!--              <option value="1">Yes</option>-->
<!--            </select>-->
<!--          </div>-->
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="registration_fee">Registration Fee <span class="c-required">*</span></label>
            <input type="number" v-model="land_buy.registration_fee"  v-validate="'required|numeric'"  id="registration_fee" name="registration_fee" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Please enter registration fee also in number format</div>
          </div>
          <div class="form-group col-md-6 col-sm-6 col-lg-4">
            <label for="remarks">Remarks</label>
            <input v-model="land_buy.remarks" id="remarks" name="remarks" type="text" class="form-control form-control-sm"/>
          </div>
        </div>

        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add Land</b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update Land</b-button>
            <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('land-buy-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  props: ["land_buy","btn_edit"],

  components: {Datepicker },
  data() {
    return {
      mouzas: [],
      land_types: [],
      lands: [],
      validation_errors: {},
      show: false,
    };
  },
  mounted() {
    this.land_buy.ses_id = this.$route.params.ses_id;
    this.getCodes();
  },
  methods: {
    customDate(date) {
      this.land_buy.date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.land_buy.ses_id = this.$route.params.ses_id;
          http
            .post("api/land-buys", this.land_buy)
            .then(response => {
              if (!response.data.error) {
                this.$emit("resetForm");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getPersonLandBuys");
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.put("api/land-buys/" + this.land_buy.id, this.land_buy)
            .then(response => {
              if (!response.data.error) {
                this.$bvModal.hide("land-buy-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getPersonLandBuys");
              } else {
                this.$bvToast.toast("Update Failed", {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
              this.$bvToast.toast("Update Failed", {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger"
              });
            });
        }
      });
    },
    getCodes() {
      http.get("api/land-alternative/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.land_types = data.land_types;
          this.mouzas = data.mouzas;
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
<style>
  .c-required{
    color: red;
  }
</style>
